import { constants } from '../common/constants/constants';

/**
 * The customer app's page for a report's share link, in the viewer's language (SC-QA-119 PR 5). The customer app's
 * language detector reads `lng` first, and the page then asks the API for the report in that language, so a dealer or
 * Super Admin reads it in the language of their own dealer app. Without a language the customer app picks it as before.
 */
export const sharedReportUrl = (sharedLink, lang) => {
    const url = `${constants.BASE_URL_USER}/shared-report/${encodeURIComponent(sharedLink)}`;
    return lang ? `${url}?lng=${encodeURIComponent(lang)}` : url;
};
